import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Projects() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative py-24 bg-gradient-to-br from-amber-50 to-orange-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
                Our Projects
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                See our craftsmanship in action through our completed projects
              </p>
            </div>
          </div>
        </section>

        {/* Instagram Showcase */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Follow Us on Instagram
              </h2>
              <p className="text-xl text-gray-600 mb-8">
                Check out our latest projects and behind-the-scenes work
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <div className="rounded-lg overflow-hidden shadow-lg">
                <iframe
                  src="https://www.instagram.com/reel/DSInfUWDknE/embed"
                  className="w-full h-[600px]"
                  frameBorder="0"
                  scrolling="no"
                  allowTransparency={true}
                  title="Instagram Reel 1"
                ></iframe>
              </div>

              <div className="rounded-lg overflow-hidden shadow-lg">
                <iframe
                  src="https://www.instagram.com/reel/DSInfUWDknE/embed"
                  className="w-full h-[600px]"
                  frameBorder="0"
                  scrolling="no"
                  allowTransparency={true}
                  title="Instagram Reel 2"
                ></iframe>
              </div>

              <div className="rounded-lg overflow-hidden shadow-lg">
                <iframe
                  src="https://www.instagram.com/reels/DSTMteCjnMW/embed"
                  className="w-full h-[600px]"
                  frameBorder="0"
                  scrolling="no"
                  allowTransparency={true}
                  title="Instagram Reel 3"
                ></iframe>
              </div>
            </div>

            <div className="text-center">
              <a
                href="https://www.instagram.com/ddrconstructionsolutions/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                style={{
                  background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)'
                }}
              >
                <i className="ri-instagram-line mr-2 text-xl"></i>
                View Our Instagram
              </a>
            </div>
          </div>
        </section>

        {/* Project Gallery */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Featured Projects
              </h2>
              <p className="text-xl text-gray-600">
                A showcase of our quality workmanship
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
                <div className="w-full h-64">
                  <img
                    src="https://public.readdy.ai/ai/img_res/9cb70bf5a6dbe1994a5a19e624a2cee9.jpg"
                    alt="Custom Deck Project"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Custom Deck Construction</h3>
                  <p className="text-gray-600">Complete deck build with custom railings and premium materials</p>
                </div>
              </div>

              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
                <div className="w-full h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Restored%20vintage%20wooden%20windows%20with%20fresh%20paint%20and%20new%20hardware%2C%20showing%20detailed%20carpentry%20work%20and%20preservation%20of%20original%20character%20in%20historic%20home%20renovation%20project&width=400&height=300&seq=project-windows-1&orientation=landscape"
                    alt="Window Restoration Project"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Window Restoration</h3>
                  <p className="text-gray-600">Saved and restored original wooden windows to their former glory</p>
                </div>
              </div>

              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
                <div className="w-full h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20Juliet%20balcony%20with%20ornate%20iron%20railing%20and%20French%20doors%2C%20custom%20designed%20architectural%20feature%20on%20residential%20home%20exterior%20with%20beautiful%20craftsmanship%20details&width=400&height=300&seq=project-juliet-1&orientation=landscape"
                    alt="Juliet Deck Project"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Unique Juliet Deck</h3>
                  <p className="text-gray-600">Custom designed Juliet deck with elegant details</p>
                </div>
              </div>

              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
                <div className="w-full h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Custom%20wooden%20privacy%20fence%20gate%20with%20modern%20design%20and%20quality%20hardware%2C%20professional%20installation%20in%20residential%20backyard%20with%20clean%20construction%20and%20sturdy%20posts&width=400&height=300&seq=project-gate-1&orientation=landscape"
                    alt="Gate Installation Project"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Custom Gate Installation</h3>
                  <p className="text-gray-600">Quality gate construction for backyard security and style</p>
                </div>
              </div>

              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
                <div className="w-full h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Handcrafted%20wooden%20picnic%20tables%20with%20foldable%20legs%2C%20showing%20quality%20carpentry%20and%20attention%20to%20detail%2C%20portable%20outdoor%20furniture%20with%20smooth%20finish%20and%20sturdy%20construction&width=400&height=300&seq=project-picnic-1&orientation=landscape"
                    alt="Picnic Tables Project"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Custom Picnic Tables</h3>
                  <p className="text-gray-600">Handcrafted picnic tables with foldable legs for easy transport</p>
                </div>
              </div>

              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
                <div className="w-full h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=Home%20exterior%20wood%20repair%20and%20restoration%20work%2C%20showing%20replaced%20rotted%20wood%20siding%20and%20trim%20with%20fresh%20materials%2C%20professional%20carpentry%20repair%20on%20residential%20house&width=400&height=300&seq=project-repair-1&orientation=landscape"
                    alt="Wood Repair Project"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Wood Repair & Restoration</h3>
                  <p className="text-gray-600">Expert repair of rotted and damaged wood structures</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="py-20 bg-amber-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Ready to Start Your Project?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              Contact us today for a free estimate
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:502-533-0524"
                className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-amber-600 bg-white rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Call 502-533-0524
              </a>
              <a
                href="/#contact"
                className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-gray-900 rounded-lg hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Request Free Estimate
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
